import { createIcon } from "@chakra-ui/react";

/**
 * BLD2-459: Speaker icon for the Read Aloud notification panel.
 *
 * 24x24 viewBox. Filled speaker silhouette with three sound waves.
 * Sized to drop into ObjectIcons alongside Play / Pause / Stop.
 */
export const VolumeHigh = createIcon({
  displayName: "VolumeHigh",
  viewBox: "0 0 24 24",
  path: [
    <g key="volume-high" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 3.18a1.5 1.5 0 0 0-2.46-1.15L6.46 5.75H3.75A1.75 1.75 0 0 0 2 7.5v9c0 .97.78 1.75 1.75 1.75h2.71l4.58 3.72A1.5 1.5 0 0 0 13.5 20.82V3.18Zm-2 1.41v14.82L7.41 16.1a1 1 0 0 0-.63-.22H4V8.13h2.78a1 1 0 0 0 .63-.22l4.09-3.32Z"
      />
      <path d="M17.05 7.05a1 1 0 0 1 1.41 0A6.97 6.97 0 0 1 20.5 12a6.97 6.97 0 0 1-2.04 4.95 1 1 0 0 1-1.41-1.41A4.98 4.98 0 0 0 18.5 12c0-1.38-.56-2.63-1.45-3.54a1 1 0 0 1 0-1.41Z" />
      <path d="M15.45 9.55a1 1 0 0 1 1.41 0A3.49 3.49 0 0 1 17.9 12a3.49 3.49 0 0 1-1.04 2.45 1 1 0 0 1-1.41-1.41c.27-.27.45-.65.45-1.04 0-.39-.18-.77-.45-1.04a1 1 0 0 1 0-1.41Z" />
    </g>
  ],
  defaultProps: {
    "aria-label": "A speaker with sound waves"
  }
});
